import React from 'react';
import { UI_CONSTANTS } from '../../constants/uiConstants';
import { formatCustomerCount, combineClasses } from '../../utils/formatters';

const StatsSection = ({ stats }) => {
  const statsData = [
    {
      value: stats.serviceRating,
      label: "Service Rating",
      id: "rating"
    },
    {
      value: formatCustomerCount(stats.totalCustomers),
      label: "Happy Families",
      id: "customers"
    },
    {
      value: formatCustomerCount(stats.verifiedPandits),
      label: "Verified Pandits",
      id: "pandits"
    }
  ];

  return (
    <div className="grid grid-cols-3 gap-4 max-w-lg mx-auto">
      {statsData.map((stat) => (
        <div key={stat.id} className="text-center">
          <div className={combineClasses(
            "font-bold text-orange-600",
            UI_CONSTANTS.TYPOGRAPHY.HEADING_2
          )}>
            {stat.value}
          </div>
          <div className={combineClasses(
            "text-gray-600",
            UI_CONSTANTS.TYPOGRAPHY.CAPTION
          )}>
            {stat.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsSection;
